import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from 'components/Shared/Common/Button';

class Section extends PureComponent {
    render() {
        const {
            header,
            children,
            onClick,
            isExpandable,
            isExpanded
        } = this.props;

        return (
            <div className="side-panel-container">
                <div className="side-panel-title">
                    {header}
                    {isExpandable && (
                        <Button
                            color="secondary"
                            size="xs"
                            onClick={onClick}
                            className={classNames(
                                'reduce_panel',
                                { active: isExpanded }
                            )}
                            iconName={isExpanded ? 'ChevronRight' : 'ChevronLeft'}
                        />
                    )}
                </div>
                <div className="side-panel-wrapper">
                    {children}
                </div>
            </div>
        );
    }
}

Section.propTypes = {
    header: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    onClick: PropTypes.func,
    isExpandable: PropTypes.bool,
    isExpanded: PropTypes.bool
};

Section.defaultProps = {
    onClick: () => null,
    isExpandable: false,
    isExpanded: true
};

export default Section;
